import React from 'react'
import { Route, Switch } from 'react-router-dom'
import loadable from '@loadable/component'

import ExploreRegion from '../pages/static/Region'
import {
  Login,
  Signup,
  ResetPassword,
  ResendConfirmation,
  NewPassword,
  SetPassword,
} from '../components/auth'

import Onboarding from '../pages/hostOnboarding/onboarding'
import OnboardingUsa from '../pages/hostOnboarding/onboardingUsa'
import StorytellerOnboarding from '../pages/storytellerOnboarding'
import AboutStoriesHost from '../pages/aboutStories/Host'
import AboutStoriesCustomer from '../pages/aboutStories/Customer'
import AboutStoriesStoryteller from '../pages/aboutStories/Storyteller'
import Contact from '../pages/static/Contact'
import HowItWorks from '../pages/static/HowItWorks'
import About from '../pages/static/About'
import Team from '../pages/static/Team'
import Home, { marketPathConstraints } from '../pages/home'
import Collection from '../pages/collections/Collection'
import ConfirmEmail from '../components/auth/ConfirmEmail'
import DownloadApp from '../pages/downloadApp'

import VoucherRedeem from '../pages/vouchers/Redeem'
import VoucherLanding from '../pages/vouchers'

import AdventureDetailsPage from '../pages/adventure/AdventureDetailsPage'
import Story from '../pages/story'
import Listing from '../pages/listing'

import SearchLoadingView from '../components/layout/ItemGridWithMap/LoadingView'

import XMasVouchers from '../readymade/pages/XmasVouchers'

const SearchResults = loadable(
  () => import('../search' /* webpackChunkName: "search" */),
  {
    fallback: <SearchLoadingView />,
  }
)

export default (
  <Switch>
    <Route exact path="/login" component={Login} />
    <Route exact path="/signup" component={Signup} />
    <Route exact path="/set-password" component={SetPassword} />
    <Route exact path="/reset-password" component={ResetPassword} />
    <Route exact path="/new-password" component={NewPassword} />
    <Route exact path="/resend-confirmation" component={ResendConfirmation} />
    <Route exact path="/confirm-email" component={ConfirmEmail} />

    <Route
      exact
      path="/(vic|nsw|nz|washington|oregon)/:regionId"
      component={ExploreRegion}
    />
    <Route path="/about" component={About} />
    <Route path="/team" component={Team} />

    <Route path="/stories-hosts" component={AboutStoriesHost} />
    <Route path="/stories-travellers" component={AboutStoriesCustomer} />
    <Route path="/stories-storytellers" component={AboutStoriesStoryteller} />

    <Route exact path="/vouchers/christmas" component={XMasVouchers} />

    <Route path="/onboarding" component={Onboarding} />
    <Route path="/storyteller-onboarding" component={StorytellerOnboarding} />
    <Route path="/list-with-us" component={Onboarding} />
    <Route path="/hosting/usa" component={OnboardingUsa} />
    <Route path="/how-it-works" component={HowItWorks} />
    <Route path="/contact-us" component={Contact} />
    <Route path="/download" component={DownloadApp} />

    <Route exact path="/redeem" component={VoucherRedeem} />
    <Route exact path="/vouchers" component={VoucherLanding} />

    <Route path="/adventures/:id" component={AdventureDetailsPage} />
    <Route path="/stories/:id" component={Story} />
    <Route path="/listings/:id" component={Listing} />

    <Route path="/collections/:slug" component={Collection} />

    <Route exact path="/listings" component={SearchResults} />

    <Route exact path={`/:market${marketPathConstraints}`} component={Home} />
    <Route exact path="/home" component={Home} />
    <Route exact path="/" component={Home} />
  </Switch>
)
